module.exports = __webpack_public_path__ + "img/captureerror.f0b1684f.svg";